import { PaxTypeCode } from 'gql/autogen/PaxTypeCode';

export interface CuscoCampaignResponse {
    isSuccess: boolean;
    result?: CardCampaignsResponse;
    error?: ApiErrorInfo;
}

export interface CardCampaignsResponse {
    sections: CampaignSection[];
}

interface CampaignSection {
    sectionName: string;
    cards: CardCampaignInfo[];
    categories: ContentCardCampaignCategory[];
}

interface CardCampaignInfo {
    cardId: number;
    cardName: string;
    priority: number;
    cardType: string;
    categories: [];
    productFunnel: string;
    content: CardContentInfo;
    dynamicContent?: OptionMapStringString;
}

export interface ActivityContentMetaInfo {
    activity_id: string;
    city_id: string;
    offer_id: string;
    offer_option_id: string;
    booking_made: string;
    travel_date: string;
    per_pax_breakdown: string;
    logtime: string;
    activity_title: string;
    activity_image_url: string;
}

export interface PerPaxBreakdown {
    paxType: string;
    quantity: number;
    price: Price;
}

interface Price {
    exc: number;
    inc: number;
}

export interface CardContentInfo {
    imageUrl?: string;
    imageRedirectLink?: string;
    title?: string;
    description?: string;
    buttonText?: string;
    buttonUrl?: string;
    buttonType: OptionValue;
    contentMetaInfo: string;
}

export interface ContentMetaInfoPax {
    paxType: PaxTypeCode;
    quantity: number;
}

interface OptionValue {
    value?: string;
}

interface OptionMapStringString {
    value?: { [key: string]: string };
}

interface ContentCardCampaignCategory {
    categoryId: number;
    categoryName: string;
    categoryDescription?: string;
    priority: number;
    parentPriorityId?: number;
}

interface ApiErrorInfo {
    message: string;
    retryAble: boolean;
}

export enum CuscoCampaignPlatform {
    WEB_DESKTOP = 'web-desktop',
    MOBILE_WEB = 'mobile-web',
    IOS = 'ios',
    ANDROID = 'android',
    YCS = 'ycs',
    WEB_DESKTOP_MOBILE = 'web-desktop-mobile',
    WECHAT_MP = 'wechat-mp',
    UNKNOWN = 'unknown',
}

export const ActivitiesCampaignCardId = 3590;
